import clickOutside from '@/directive/clickOutSide/clickoutside';
var directivesList = [{
  name: 'clickOutside',
  directive: clickOutside
}];
export default (function (Vue) {
  directivesList.forEach(function (d) {
    Vue.directive(d.name, d.directive);
  });
});